import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton, InputAdornment } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CountrySelect from "../../Components/CountrySelect";
import PhoneNumberInput from "../../Components/PhoneNumberInput";
import { getResellerByIdAPI } from "../../DAL/fetch";
import { updateResellerAPI } from "../../DAL/update";
import { fileUrl } from "../../Config/Config";

const AddReseller = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    name: "",
    email: "",
    country: "",
    phone: "",
    whatsapp: "",
    password: "",
    picture: "",
  });
  const [error, setError] = useState("");
  const [pictureFile, setPictureFile] = useState(null);
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [password, setPassword] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value;

    setInputs((prev) => ({
      ...prev,
      [name]: trimmedValue,
    }));

    if (name === "password") {
      const trimmed = value.trim();
      const hasMultipleSpaces = /\s{2,}/.test(value);
      setPasswordError(!trimmed || hasMultipleSpaces);
    }
  };

  const handleCountryChange = (selected) => {
    setInputs((prev) => ({
      ...prev,
      country: selected || null,
    }));
  };

  const handlePhoneChange = (value) => {
    if (!/^\d+$/.test(value)) {
      setError("Phone must contain digits only");
    } else if (value.length !== 12) {
      setError("Phone number must be exactly 14 digits including country code");
    } else {
      setError("");
    }
    setInputs((prev) => ({ ...prev, phone: value, whatsapp: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPictureFile(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { name, email, country, phone, whatsapp, password } = inputs;

    const requiredFields = [name, email, country, phone, whatsapp];
    const areFieldsFilled = requiredFields.every((field) =>
      typeof field === "string" ? field.trim() !== "" : !!field
    );
    try {
      let resp;
      const formData = new FormData();
      formData.append("name", inputs?.name);
      formData.append("email", inputs?.email);
      formData.append("country", inputs.country);
      formData.append("phone", inputs?.phone);
      formData.append("whatsapp", inputs?.whatsapp);
      // formData.append("password", inputs?.password);
      if (image) {
        formData.append("file", image);
      }

      resp = await updateResellerAPI(id, formData);

      if (resp?.status === 200) {
        enqueueSnackbar(resp?.data?.message, { variant: "success" });
        navigate(-1);
      } else if (resp?.status === 400) {
        enqueueSnackbar(resp?.error, { variant: "error" });
      } else {
        enqueueSnackbar(
          resp?.data?.message ||
            resp?.data?.error ||
            resp?.message ||
            resp?.error,
          { variant: "error" }
        );
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.error("Submit error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchReseller = async () => {
    try {
      setLoading(true);
      const resp = await getResellerByIdAPI(id);
      if (resp?.status === 200) {
        const data = resp?.data?.data;
        setLoading(false);
        setInputs({
          name: data?.name || "",
          email: data?.email || "",
          country: data?.country || "",
          phone: data?.phone || "",
          whatsapp: data?.whatsapp || "",
          picture: data?.picture || "",
          password: "",
        });

        if (data?.fileUrl) {
          setPictureFile(data.fileUrl);
        }
      } else {
        enqueueSnackbar("Failed to fetch reseller details", {
          variant: "error",
        });
        setLoading(false);
      }
    } catch (error) {
      console.error("Fetch Reseller Error:", error);
      enqueueSnackbar("Error fetching reseller", { variant: "error" });
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchReseller();
  }, [id]);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          position: "sticky",
          top: "10px",
        }}
      >
        <ArrowBackIcon
          onClick={() => navigate(-1)}
          sx={{ cursor: "pointer", fontSize: "15px" }}
        />
        <Typography variant="body1">
          {id ? "Update Reseller" : "Add New Reseller"}
        </Typography>
      </Box>

      <Grid container justifyContent="center" mt={1}>
        <Grid item xs={12} sm={10} md={8}>
          <CardContent>
            <Grid container spacing={2} my={3}>
              {/* {inputs?.picture && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    width: "100%",
                    margin: "0 auto",
                  }}
                >
                  <Box
                    component="img"
                    src={
                      inputs?.picture?.startsWith("/")
                        ? fileUrl + inputs?.picture
                        : fileUrl + "/" + inputs?.picture
                    }
                    alt="image"
                    sx={{
                      width: 100,
                      height: 100,
                      objectFit: "contain",
                      borderRadius: "50%",
                    }}
                  />
                </Box>
              )} */}
              {(inputs?.picture || pictureFile) && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    width: "100%",
                    margin: "0 auto",
                  }}
                >
                  <Box
                    component="img"
                    src={
                      pictureFile
                        ? pictureFile
                        : inputs?.picture?.startsWith("/")
                        ? fileUrl + inputs?.picture
                        : fileUrl + "/" + inputs?.picture
                    }
                    alt="image"
                    onClick={() => document.getElementById("fileInput").click()} // 👈 Avatar click
                    sx={{
                      width: 100,
                      height: 100,
                      objectFit: "cover",
                      borderRadius: "50%",
                      cursor: "pointer", // 👈 cursor pointer
                      border: "2px solid #ccc",
                    }}
                  />
                </Box>
              )}

              <input
                type="file"
                id="fileInput"
                accept="image/*"
                onChange={handleImageUpload}
                style={{ display: "none" }} // 👈 hide input
              />

              <Grid item lg={12}>
                <TextField
                  label="Name *"
                  name="name"
                  value={inputs?.name}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  type="name"
                  placeholder={id ? "Name" : ""}
                  error={inputs?.name.length > 0 && inputs?.name.length < 5}
                  inputProps={{ maxLength: 25 }}
                  autoComplete="off"
                />
              </Grid>
              <Grid item lg={12}>
                <TextField
                  label="Email *"
                  name="email"
                  value={inputs?.email}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  type="email"
                  placeholder={id ? "Leave blank to keep old email" : ""}
                  autoComplete="off"
                />
              </Grid>
              <Grid item lg={12}>
                {id ? (
                  <TextField
                    label="Country *"
                    name="country"
                    value={inputs?.country}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    type="email"
                    autoComplete="off"
                  />
                ) : (
                  <div style={{ width: "100%" }}>
                    <CountrySelect
                      value={inputs.country}
                      onChange={handleCountryChange}
                    />
                  </div>
                )}
              </Grid>
              <Grid item lg={12}>
                <PhoneNumberInput
                  country={inputs.country?.value?.toLowerCase()}
                  value={inputs.phone}
                  onChange={handlePhoneChange}
                  error={error}
                />
                <FormHelperText sx={{ color: "error.main" }}>
                  {error}
                </FormHelperText>
              </Grid>
              <Grid item lg={12}>
                <TextField
                  label="Whatsapp *"
                  name="whatsapp"
                  value={inputs?.whatsapp}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  type="text"
                  placeholder="Enter WhatsApp Number"
                  inputProps={{
                    maxLength: 18,
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                  autoComplete="off"
                />
                <FormHelperText sx={{ color: "error.main" }}>
                  {error}
                </FormHelperText>
              </Grid>
              {/* {id ? (
                <></>
              ) : (
                <>
                  <Grid item lg={12}>
                    <TextField
                      required
                      type={visible ? "text" : "password"}
                      label="Password"
                      value={inputs?.password}
                      onChange={handleChange}
                      name="password"
                      error={passwordError}
                      autoComplete="off"
                      helperText={
                        passwordError
                          ? "Password cannot be empty or contain multiple spaces"
                          : ""
                      }
                      fullWidth
                      size="small"
                      sx={{ mb: 2 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setVisible(!visible)}
                              edge="end"
                            >
                              {visible ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid> */}
              {/* <Grid item xs={12} sm={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    name="image"
                    onChange={handleImageUpload}
                    style={{
                      border: "1px solid black",
                      padding: "10px",
                      borderRadius: "3px",
                    }}
                  />
                  {pictureFile && (
                    <img
                      src={pictureFile}
                      alt="Preview"
                      style={{ width: "150px", marginTop: "10px" }}
                    />
                  )}
                </Box>
              </Grid> */}
              {/* </> */}
              {/* )} */}
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  className="gradient-btn"
                  onClick={handleSubmit}
                >
                  {loading ? (
                    <CircularProgress size={25} sx={{ color: "white" }} />
                  ) : (
                    <>{id ? "Update" : "Submit"}</>
                  )}
                </Button>
              </Grid>
            </Grid>
          </CardContent>
          {/* </Card> */}
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddReseller;
